import React from 'react';
import styles from './TimerSection.module.css';
import { TimerSectionProps } from './TimerSection.types';

const TimerSection = ({ firsNum, secNum, bgColor, numColor }: TimerSectionProps) => {
  return (
    <div className={styles.counter__numbers}>
      <div
        className={styles.counter__number}
        style={{ color: numColor, background: bgColor }}
      >
        {firsNum}
      </div>
      <div
        className={styles.counter__number}
        style={{ color: numColor, background: bgColor }}
      >
        {secNum}
      </div>
    </div>
  );
};

export default TimerSection;
